/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AssignmentIn } from './assignmentIn';

export interface AssignIn {
  /**
     * @minItems 1
     * @maxItems 200
     */
  assignments: AssignmentIn[];
}
